<template>
  <button 
    type="button" 
    class="btn btn-vigo-zurueck rounded-pill d-flex align-items-center justify-content-center gap-2"
    :disabled="disabled"
  >
    <svg 
      class="chevron-icon" 
      width="20" 
      height="21" 
      viewBox="0 0 20 21" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M7.5 4.25L13.75 10.5L7.5 16.75" 
        stroke="currentColor" 
        stroke-width="2" 
        stroke-linecap="round" 
        stroke-linejoin="round"
      />
    </svg>
    <span class="btn-text">zurück</span>
  </button>
</template>

<script setup>
// Zurück-Button Komponente basierend auf Figma Design
defineProps({
  disabled: {
    type: Boolean,
    default: false
  }
});
</script>

<style scoped>
.btn-vigo-zurueck {
  background-color: var(--vigo-2-100-bg);
  color: var(--vigo-1-600-text);
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  padding: 12px 24px;
  border: none;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.btn-vigo-zurueck:hover,
.btn-vigo-zurueck:focus-visible {
  background-color: var(--vigo-2-300-bg);
  color: var(--vigo-1-600-text);
}

.btn-vigo-zurueck:active {
  background-color: var(--vigo-2-300-bg);
}

.btn-vigo-zurueck:disabled {
  background-color: #e0e0e0;
  color: #999999;
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-vigo-zurueck:disabled:hover {
  background-color: #e0e0e0;
  color: #999999;
}

.btn-text {
  white-space: nowrap;
}

.chevron-icon {
  width: 20px;
  height: 21px;
  flex-shrink: 0;
  transform: rotate(180deg);
}
</style>
